import { Reveal } from "@/components/motion";
import { motion } from "framer-motion";

const doctors = [
  {
    name: "Dr. Syed Liaqet Hussain",
    degree: "M.S. Ophthalmology",
    expertise: "PHACO & LASIK Expert",
    img: "/assets/dr-liaqet.png",
    testid: "doctor-liaqet",
  },
  {
    name: "Dr. Syed Zeeshan",
    degree: "M.S. Ophthalmology",
    expertise: "PHACO & Medical Retina Expert",
    img: "/assets/dr-zeeshan.png",
    testid: "doctor-zeeshan",
  },
];

export default function Consultants() {
  return (
    <section id="consultants" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-[var(--teal)] text-sm tracking-[0.25em] uppercase mb-4">Our Consultants</p>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl tracking-tight text-[var(--ink)] max-w-2xl">
            Specialists you can trust with your sight.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
          {doctors.map((d, i) => (
            <Reveal key={d.testid} delay={i * 0.12}>
              <motion.div
                whileHover={{ y: -8 }}
                transition={{ type: "spring", stiffness: 300, damping: 20 }}
                data-testid={d.testid}
                className="group relative rounded-3xl overflow-hidden bg-[var(--teal-dark)] shadow-[0_20px_50px_rgb(0,0,0,0.08)]"
              >
                <div className="relative h-[460px] sm:h-[520px] overflow-hidden">
                  <img src={d.img} alt={d.name} className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[var(--teal-dark)] via-[var(--teal-dark)]/20 to-transparent" />
                </div>
                <div className="absolute bottom-0 inset-x-0 p-7 sm:p-8">
                  <h3 className="font-display text-3xl sm:text-4xl text-white">{d.name}</h3>
                  <p className="mt-2 text-[var(--teal-light)] font-medium">{d.degree}</p>
                  <span className="mt-3 inline-block px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-white text-sm border border-white/20">
                    {d.expertise}
                  </span>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
